import { Button, Modal } from "flowbite-react";
import { FlatButton } from "../buttons";

export function Popup({
  className,
  modalState,
  alignActions = "center",
  onClose,
  onCancel,
  onConfirm,
  header,
  fullHeader = '',
  content,
  cancelText = "Cancel",
  confirmText = "Confirm",
  cancelClass,
  confirmClass,
  size = "md",
  isConfirm = true,
  bodyClass
}) {
  const [openModal, setOpenModal] = modalState;
  return (
    <Modal
      show={openModal}
      size={size}
      popup
      onClose={() => {
        onClose && onClose();
        setOpenModal();
      }}
      className={className}
    >
      <Modal.Header>
        {fullHeader != '' ? <>{fullHeader}</> : <h2 className="p-2">{header}</h2>}
      </Modal.Header>

      <Modal.Body className={bodyClass}>
        <div className="text-center">
          {content}
        {isConfirm && <div className={`flex justify-${alignActions} gap-4`}>
          <FlatButton
            // color="custom"
            appearance="secondary"
            id="cancel-button"
            className={cancelClass}
            onClick={() => {
              onCancel && onCancel();
              setOpenModal();
            }}
          >
            {cancelText}
          </FlatButton>
          <FlatButton
            appearance="primary"
            className={confirmClass || ""}
            id="confirm-button"
            onClick={() => {
              onConfirm && onConfirm();
            }}
          >
            {confirmText}
          </FlatButton>
        </div>}
        </div>
      </Modal.Body>
    </Modal>
  );
}
